<template>
  <div>
    <v-container grid-list-xl fluid>
      <header-title title="Personal directivo"></header-title>
      <p class="grey--text text--darken-1">
        Director/a General, Académico, Administrativo Financiero y Coordinador/a
        de Unidad Académica.
      </p>
      <v-row>
        <v-col cols="12" sm="4">
          <v-autocomplete
            label="Institución"
            :items="institutions"
            v-model="options.institution_id"
            item-text="nombre"
            item-value="codigo"
            @change="getExecutiveStaff"
            clearable
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            class="mr-1"
            label="Buscar"
            v-model="options.search"
            append-icon="mdi-magnify"
            hide-details
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="error"
                class="mr-1"
                v-bind="attrs"
                v-on="on"
                @click="reportExecutiveStaffPDF"
                :disabled="executiveStaffs.length == 0"
              >
                PDF
              </v-btn>
            </template>
            <span>Directivos</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                fab
                small
                color="info"
                class="mr-1"
                v-bind="attrs"
                v-on="on"
                @click="reportExecutiveStaffGeneral"
              >
                PDF
              </v-btn>
            </template>
            <span>Directivo en general</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="executiveStaffs"
        :search="options.search"
        :items-per-page="50"
        :footer-props="{
          'items-per-page-options': [25, 50, 100, 150, -1],
        }"
        calculate-widths
        item-key="name"
        class="elevation-2"
        v-cloak
      >
        <template v-slot:[`item.numeration`]="{ item }">
          <td>
            {{ executiveStaffs.indexOf(item) + 1 }}
          </td>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <td>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  type="button"
                  color="info"
                  :loading="btn_loading"
                  @click="showDetail(item.codigo)"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-view-list-outline</v-icon>
                </v-btn>
              </template>
              <span>Ver detalle</span>
            </v-tooltip>
          </td>
        </template>
      </v-data-table>
    </v-container>
    <v-dialog v-model="detailDialog" scrollable max-width="500px">
      <v-form ref="form">
        <v-card>
          <v-card-title class="headline grey lighten-3" primary-title>
            <span class="headline">Detalle</span>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <h4 class="teal--text">Datos personales</h4>
            <personal-information :person="executiveStaff" />
            <h4 class="teal--text">Formación y cargo</h4>
            <v-container grid-list-md>
              <v-row dense>
                <v-col cols="12">
                  <b>Profesión: </b>
                  {{ executiveStaff.profesion? executiveStaff.nombre_profesion:'sin dato' }}
                </v-col>
                <v-col cols="12">
                  <b>Tipo de designación: </b>
                  {{
                    executiveStaff.tipo_designacion
                      ? executiveStaff.tipo_designacion
                      : "sin dato"
                  }}
                </v-col>
                <v-col cols="12">
                  <b>Tipo de cargo: </b>
                  {{
                    executiveStaff.tipo_cargo
                      ? executiveStaff.tipo_cargo
                      : "sin dato"
                  }}
                </v-col>
                <v-col cols="12">
                  <b>Cargo: </b>
                  {{ executiveStaff.cargo ? executiveStaff.cargo : "sin dato" }}
                </v-col>
              </v-row>
            </v-container>
            <h4 class="teal--text">Ubicación</h4>
            <person-location-data :person="executiveStaff" />
            
            <h4 class="teal--text">Contacto de emergencia</h4>
            <personal-contacto-emergencia :person="executiveStaff" />
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" text @click.native="detailDialog = false"
              >Cerrar</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
/* eslint-disable no-console */
import HeaderTitle from "@/components/HeaderTitle";
import PersonalInformation from "@/components/PersonalInformation";
import PersonLocationData from "@/components/PersonLocationData.vue";
import Storage from "../../utils/storage";
import Endpoint from "../../utils/environment";
import PDFService from "../../utils/pdf";
import Service from "../../services/request";
import { mapActions } from "vuex";

import PersonalContactoEmergencia from "@/components/PersonalContactoEmergencia";

export default {
  name: "executive-staff",
  components: {
    HeaderTitle,
    PersonalInformation,
    PersonLocationData,
    PersonalContactoEmergencia,
  },
  data() {
    return {
      loading: false,
      btn_loading: false,
      pdf_loading: false,
      headers: [
        { text: "#", value: "numeration", align: "left", sortable: false },
        { text: "Código ", value: "codigo", sortable: false },
        { text: "Apellidos y Nombres ", value: "nombre" },
        { text: "Cédula Identidad ", value: "cedula" },
        { text: "RDA ", value: "rda", sortable: false },
        { text: "Cargo ", value: "cargo" },
        { text: "Teléfono", value: "telefono", sortable: false },
        { text: "Acciones ", value: "actions", sortable: false },
      ],
      institutions: [],
      executiveStaffs: [],
      executiveStaff: {
        canton: "",
        cedula: "",
        cod_pers: "",
        correo: "",
        departamento: "",
        domicilio: "",
        estado: null,
        estado_civil: "",
        expedido: "",
        fecha_etado: "",
        fecha_nacimiento: "",
        genero: "",
        grupo_sangui: "",
        localidad: "",
        municipio: "",
        nombre: "",
        profesion: "",
        provincia: "",
        rda: "",
        telefono: "",
        modalidad: "",
      },
      options: {
        search: "",
        institution_id: "",
      },
      detailDialog: false,
      user: null,
      serve: "",
    };
  },
  created() {
    this.serve = Endpoint.getServe();
  },
  mounted() {
    this.user = Storage.getUser();
    if (this.user && this.user.rid == 1) {
      this.getInstitutionParameter();
    } else {
      this.$router.replace({ name: "dashboard" });
    }
  },
  methods: {
    ...mapActions(["toast"]),
    getInstitutionParameter() {
      Service.svcInstitutionParameter("get")
        .then((response) => {
          this.institutions = response.data;
        })
        .catch((error) => {
          console.error("No cargo los registros", error);
        });
    },
    getExecutiveStaff() {
      this.loading = true;
      Service.svcExecutiveStaff("post", this.options)
        .then((response) => {
          this.loading = false;
          this.executiveStaffs = response.data;
        })
        .catch((error) => {
          this.loading = false;
          console.error("Error al cargar registros", error);
        });
    },
    showDetail(person_code) {
      this.btn_loading = true;
      Service.svcPersonById("get", { person_code: person_code })
        .then((response) => {
          this.btn_loading = false;
          this.executiveStaff = response.data;
          this.detailDialog = true;
        })
        .catch((error) => {
          this.btn_loading = false;
          console.error("No cargo el registro", error);
        });
    },
    clearFilter() {
      this.options.institution_id = "";
      this.executiveStaffs = [];
    },
    reportExecutiveStaffPDF() {
      this.pdf_loading = false;
      const institution = this.institutions.find(
        (item) => item.codigo === this.options.institution_id
      );
      PDFService.pdfStaff("DIRECTIVO", institution, this.executiveStaffs);
    },
    reportExecutiveStaffGeneral() {
      this.pdf_loading = false;
      Service.svcExecutiveStaffGeneral("get")
        .then((response) => {
          this.pdf_loading = false;
          PDFService.pdfStaffGeneral("DIRECTIVO", response.data);
        })
        .catch(() => {
          this.pdf_loading = false;
        });
    },
  },
};
</script>
